/* eslint-disable react/prop-types */
/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-native/no-color-literals */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import SociollaText from '@components/sociolla/SociollaText';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import FileInput from '@components/form/FileInput';
import CheckBox from '@components/form/CheckBox';
import ModalHalf from '@components/modal/ModalHalf';
import Image from '@components/global/Image';
import ItemDetail from '@components/global/ItemDetail';
import StatusBadge from '@components/global/StatusBadge';
import StatusPicker from '@components/form/StatusPicker';
import TableMobile from '@components/table/TableMobile';

import { ButtonSticky } from '@components/screen/Layout';
import {
  currency,
  parseDate,
  downloadFile,
  getFileNameFromUrl,
} from '@global/helpers';
import Colors from '@global/colors';
import { isAndroid, isWeb } from '@global/screens';
import { MsAccount } from '@api/ms-account';
import { showAlert } from '@/store/global';
import { showPopup } from '@/store/modal';
import { logEvent } from '@global/analytics';

const trash = {
  width: 14,
  height: 18,
};

const INVOICE_PAYMENT_STATUS_OPTIONS = [
  { label: 'Fully Paid', value: 'fully_paid' },
  { label: 'Partially Paid', value: 'partially_paid' },
  { label: 'Not Paid', value: 'not_paid' },
];

const getInvoiceAmountError = (detail = {}, maxAmount) =>
  detail.status === 'partially_paid' &&
  maxAmount !== undefined &&
  Number(detail.amount) > maxAmount
    ? 'Amount input is exceeds invoice actual amount'
    : '';

const isInvoiceDetailValid = (detail = {}, maxAmount) =>
  Boolean(detail.text) &&
  Boolean(detail.status) &&
  (detail.status !== 'partially_paid' ||
    (detail.amount !== '' &&
      detail.amount !== null &&
      detail.amount !== undefined &&
      !Number.isNaN(Number(detail.amount)))) &&
  !getInvoiceAmountError(detail, maxAmount);

const TodoInvoice = ({
  containerHeight = 0,
  detailData = {},
  detailTodo = {},
  detailCustomer = {},
  localPayload = null,
  onSubmit = () => {},
  onSaveDraft = () => {},
  resetTab = () => {},
}) => {
  const dispatch = useDispatch();
  const isLoadingGlobal = useSelector((state) => state.modal.isLoading);
  const [showResult, setShowResult] = useState(false);
  const addingMoreNote = React.useRef(false);
  const [showDetailInvoice, setShowDetailInvoice] = useState({});
  const [showNote, setShowNote] = useState(false);
  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [invoiceKeyword, setInvoiceKeyword] = useState('');
  const [invoices, setInvoices] = useState([]);
  const [editingNoteIndex, setEditingNoteIndex] = useState(-1);
  const [payloadInvoices, setPayloadInvoices] = useState([]);
  const [payloadInvoiceNotes, setPayloadInvoiceNotes] = useState('');
  const [payloadInvoiceAmount, setPayloadInvoiceAmount] = useState('');
  const [payloadInvoiceStatus, setPayloadInvoiceStatus] = useState('');
  const [invoiceAttachmentUrl, setInvoiceAttachmentUrl] = useState('');
  const [payloadInvoiceDetails, setPayloadInvoiceDetails] = useState([]);
  const [lastPayload, setLastPayload] = useState([]);

  const lockedInvoices = useMemo(
    () =>
      lastPayload
        .filter((_, idx) => idx !== editingNoteIndex)
        .flatMap((note) => note.invoice_number || []),
    [lastPayload, editingNoteIndex],
  );

  const selectedTotal = useMemo(
    () =>
      invoices
        .filter((inv) => payloadInvoices.includes(inv.id))
        .reduce((sum, inv) => sum + (inv.total_amount || 0), 0),
    [invoices, payloadInvoices],
  );

  const filteredInvoices = useMemo(() => {
    return invoices.filter((item) => {
      if (lockedInvoices.includes(item.id)) {
        return false;
      }
      if (!invoiceKeyword) {
        return true;
      }
      const checkMatch = (val) => {
        try {
          const keyword = invoiceKeyword
            .replace(new RegExp(' ', 'g'), '')
            .toLowerCase();
          const cleaned = val.toLowerCase().replace(new RegExp('/', 'g'), ' ');
          return cleaned
            .split(' ')
            .some(
              (part) =>
                part && (keyword.includes(part) || part.includes(keyword)),
            );
        } catch {
          return false;
        }
      };
      return (
        (item.invoice_origin ? checkMatch(item.invoice_origin) : false) ||
        (item.id ? checkMatch(item.id) : false)
      );
    });
  }, [invoices, lockedInvoices, invoiceKeyword]);

  const allVisibleSelected =
    filteredInvoices.length > 0 &&
    filteredInvoices.every((inv) => payloadInvoices.includes(inv.id));

  const toggleSelectAll = () => {
    if (allVisibleSelected) {
      setPayloadInvoices((prev) =>
        prev.filter((id) => !filteredInvoices.find((inv) => inv.id === id)),
      );
    } else {
      const toAdd = filteredInvoices
        .map((inv) => inv.id)
        .filter((id) => !payloadInvoices.includes(id));
      setPayloadInvoices((prev) => [...prev, ...toAdd]);
    }
  };

  const getCustomerInvoice = async (id) => {
    setLoadingInvoice(true);
    try {
      const response = await MsAccount.getCustomerInvoice(id);
      if (response?.data?.data?.length) {
        const result = response.data.data.map((item) => ({
          id: item.invoice_payment_ref || item.name,
          total_amount: Number(item.amount_residual || 0),
          status: item.state,
          amount_tax_signed: item.amount_untaxed,
          invoice_origin: item.invoice_origin,
          invoice_payment_state: item.invoice_payment_state,
          invoice_date: item.invoice_date,
          invoice_date_due: item.invoice_date_due,
          date: item.date,
        }));
        setInvoices(result);
      }
      setLoadingInvoice(false);
    } catch (error) {
      setLoadingInvoice(false);
    }
  };

  const onSubmitInvoices = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const payload = {
        more_info: {
          notes: lastPayload,
        },
      };
      logEvent({
        eventName: 'submit_activity',
        data: {
          activity_id: detailData?._id,
          task_id: detailTodo?._id,
          type: 'invoice_collection',
          payload: JSON.stringify(payload),
        },
        dataKey: 'detail',
      });
      await onSubmit({
        targetType: 'invoice_collection',
        taskId: detailTodo?._id,
        payload,
      });
      dispatch(showPopup({ name: 'isLoading', value: false }));
      resetTab();
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      let error_message = 'A system error occurred';
      if (error?.response?.data?.message) {
        error_message = error.response.data.message;
      }
      if (!detailTodo?._id) {
        error_message = 'This activity have no todo list activity.';
      }
      dispatch(
        showAlert({
          show: true,
          isModal: true,
          title: 'Error',
          description: error_message,
          isConfirm: false,
          testID: 'todo-invoice-validation',
        }),
      );
    }
  };

  const updateInvoiceDetail = (idx, field, value) => {
    setPayloadInvoiceDetails((prev) => {
      const temp = [...prev];
      temp[idx] = { ...temp[idx], [field]: value };
      return temp;
    });
  };

  const getInvoiceMaxAmount = (invoiceId) =>
    invoices.find((inv) => inv.id === invoiceId)?.total_amount;

  const getAmountForStatus = (status, invoiceId) => {
    if (status === 'fully_paid') {
      return invoices.find((inv) => inv.id === invoiceId)?.total_amount || 0;
    }
    if (status === 'not_paid') {
      return 0;
    }
    return '';
  };

  const updateInvoiceStatus = (idx, status) => {
    const invoiceId = payloadInvoiceDetails[idx]?.invoiceId;
    setPayloadInvoiceDetails((prev) => {
      const temp = [...prev];
      temp[idx] = {
        ...temp[idx],
        status,
        amount: getAmountForStatus(status, invoiceId),
      };
      return temp;
    });
  };

  const updateEditInvoiceStatus = (status) => {
    const invoiceId = payloadInvoices[0];
    setPayloadInvoiceStatus(status);
    setPayloadInvoiceAmount(getAmountForStatus(status, invoiceId));
  };

  const setInvoice = (id) => {
    const temp = JSON.parse(JSON.stringify(payloadInvoices));
    const idx = temp.indexOf(id);
    if (idx > -1) {
      temp.splice(idx, 1);
    } else {
      temp.push(id);
    }
    setPayloadInvoices(temp);
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setInvoices([]);
      setInvoiceKeyword('');
      if (detailCustomer?._id) {
        getCustomerInvoice(detailCustomer._id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [detailCustomer]);

  useEffect(() => {
    let mounted = true;
    if (mounted && !addingMoreNote.current) {
      const localNotes =
        localPayload?.more_info?.notes || localPayload?.notes || [];
      if (localNotes?.length) {
        const invoice = localNotes.filter((a) => a.type == 'invoice');
        if (invoice?.length) {
          setLastPayload(invoice);
          setShowResult(true);
        }
        return;
      }
      if (detailTodo?.more_info?.notes?.length) {
        const invoice = detailTodo.more_info.notes.filter(
          (a) => a.type == 'invoice',
        );
        if (invoice?.length) {
          setLastPayload(invoice);
          setShowResult(true);
        }
      }
    }
    return () => {
      mounted = false;
    };
  }, [detailTodo, localPayload]);

  const saveDraftRef = React.useRef(onSaveDraft);
  useEffect(() => {
    saveDraftRef.current = onSaveDraft;
  }, [onSaveDraft]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const payload = { more_info: { notes: lastPayload } };
      saveDraftRef.current({
        targetType: 'invoice_collection',
        taskId: detailTodo?._id,
        payload,
      });
    }, 500);
    return () => clearTimeout(timer);
  }, [lastPayload, detailTodo?._id]);

  return (
    <View
      testID="todo-invoice-container"
      style={{ width: '100%', height: containerHeight }}>
      {showResult ? (
        <View style={{ width: '100%' }}>
          <ScrollView
            showsVerticalScrollIndicator={false}
            style={{
              width: '100%',
              padding: 15,
              height: containerHeight - (isAndroid ? 45 : 40),
            }}>
            {lastPayload?.length
              ? lastPayload.map((item, idx) => (
                  <ResultNoteCard
                    key={idx}
                    item={item}
                    onEdit={() => {
                      setEditingNoteIndex(idx);
                      setPayloadInvoices(item.invoice_number || []);
                      setPayloadInvoiceNotes(item.text || '');
                      setPayloadInvoiceAmount(item.amount_invoice ?? '');
                      setPayloadInvoiceStatus(item.status_invoice || '');
                      setInvoiceAttachmentUrl(
                        item.invoice_attachment_url || '',
                      );
                      setShowNote(true);
                    }}
                    onDelete={() => {
                      dispatch(
                        showAlert({
                          show: true,
                          isModal: true,
                          title: 'Remove Note',
                          description:
                            'This note will be deleted. Do you want to proceed?',
                          testID: 'todo-invoice-delete-note',
                          onCallback: () => {
                            const temp = JSON.parse(
                              JSON.stringify(lastPayload),
                            );
                            temp.splice(idx, 1);
                            setLastPayload(temp);
                          },
                        }),
                      );
                    }}
                  />
                ))
              : null}
            {invoices.some((inv) => !lockedInvoices.includes(inv.id)) && (
              <View style={{ width: '100%', marginBottom: 90 }}>
                <Button
                  testID="todo-invoice-add-more-note-btn"
                  rounded
                  type="default"
                  buttonStyle={{ width: '100%' }}
                  title={
                    <SociollaText
                      type="bold"
                      style={{ fontSize: 14, letterSpacing: 0.5 }}>
                      Add More Note
                    </SociollaText>
                  }
                  onPress={() => {
                    setEditingNoteIndex(-1);
                    setPayloadInvoices([]);
                    setPayloadInvoiceNotes('');
                    setPayloadInvoiceAmount('');
                    setPayloadInvoiceStatus('');
                    setInvoiceAttachmentUrl('');
                    addingMoreNote.current = true;
                    setShowResult(false);
                  }}
                />
              </View>
            )}
          </ScrollView>
          <ButtonSticky
            show
            customHost="modal-sticky-button"
            buttons={[
              {
                title: 'Done',
                disabled: lastPayload.length && !isLoadingGlobal ? false : true,
                onPress: () => onSubmitInvoices(),
              },
            ]}
          />
        </View>
      ) : (
        <>
          <TableMobile
            placeholder="Search by order / invoice number"
            loading={loadingInvoice}
            extraData={payloadInvoices}
            onSearch={(value) => setInvoiceKeyword(value)}
            tableData={filteredInvoices}
            headerComponent={
              filteredInvoices.length > 0 ? (
                <TouchableOpacity
                  testID="todo-invoice-select-all"
                  style={styles.selectAllRow}
                  activeOpacity={0.7}
                  onPress={toggleSelectAll}>
                  <CheckBox
                    value="all"
                    checked={allVisibleSelected}
                    onChange={toggleSelectAll}
                  />
                  <SociollaText style={styles.selectAllText}>
                    Select All ({filteredInvoices.length})
                  </SociollaText>
                </TouchableOpacity>
              ) : null
            }
            emptyComponent={
              !loadingInvoice ? (
                <View style={styles.emptyState}>
                  <SociollaText style={styles.emptyStateText}>
                    No unpaid invoices found for this customer
                  </SociollaText>
                </View>
              ) : null
            }
            renderItem={({ data, index }) => {
              const isSelected = payloadInvoices.includes(data.id);
              return (
                <View
                  style={[
                    styles.orderItem,
                    isSelected && styles.orderItemSelected,
                  ]}
                  key={index}>
                  <View style={styles.orderItemSection}>
                    <View style={{ width: 35 }}>
                      <CheckBox
                        value={data.id}
                        checked={isSelected}
                        onChange={(val) => setInvoice(val)}
                      />
                    </View>
                    <TouchableOpacity
                      testID={`todo-invoice-item-detail-${index}`}
                      activeOpacity={0.6}
                      style={{ flex: 1 }}
                      onPress={() => setShowDetailInvoice(data)}>
                      <View style={styles.cardTopRow}>
                        <SociollaText
                          type="semibold"
                          style={styles.invoiceNumber}>
                          {data.id}
                        </SociollaText>
                        <StatusBadge status={data.status} />
                      </View>
                      {data.invoice_origin ? (
                        <SociollaText style={styles.invoiceOrigin}>
                          Order: {data.invoice_origin}
                        </SociollaText>
                      ) : null}
                      <View style={styles.cardBottomRow}>
                        <SociollaText style={styles.dueDateLabel}>
                          {data.invoice_date_due
                            ? `Due: ${parseDate(data.invoice_date_due)}`
                            : 'No due date'}
                        </SociollaText>
                        <SociollaText type="semibold" style={styles.amountDue}>
                          {currency(data.total_amount, true)}
                        </SociollaText>
                      </View>
                    </TouchableOpacity>
                  </View>
                </View>
              );
            }}
            footerComponent={true}
          />
          {payloadInvoices.length > 0 && (
            <View style={styles.selectionSummary}>
              <SociollaText style={styles.selectionSummaryCount}>
                {payloadInvoices.length} invoice
                {payloadInvoices.length > 1 ? 's' : ''} selected
              </SociollaText>
              <SociollaText
                type="semibold"
                style={styles.selectionSummaryTotal}>
                Total: {currency(selectedTotal, true)}
              </SociollaText>
            </View>
          )}
          <ButtonSticky
            show
            customHost="modal-sticky-button"
            buttons={[
              {
                title: Boolean(invoices?.length) ? 'Add Note' : 'Done',
                disabled: Boolean(invoices?.length)
                  ? payloadInvoices.length
                    ? false
                    : true
                  : false,
                onPress: () => {
                  if (Boolean(invoices?.length)) {
                    setPayloadInvoiceDetails(
                      payloadInvoices.map((id) => ({
                        invoiceId: id,
                        text: '',
                        status: '',
                        amount: '',
                        invoice_attachment_url: '',
                      })),
                    );
                    setShowNote(true);
                  } else {
                    onSubmitInvoices();
                  }
                },
              },
            ]}
          />
        </>
      )}

      <ModalHalf
        testID="todo-invoice-detail-modal"
        title={showDetailInvoice?.id ? showDetailInvoice.id : '-'}
        visible={Boolean(Object.keys(showDetailInvoice).length)}
        maxWidth={'100%'}
        onClose={() => setShowDetailInvoice({})}
        children={
          <ScrollView style={{ width: '100%', paddingHorizontal: 15 }}>
            <ItemDetail
              name="Journal Date"
              value={parseDate(showDetailInvoice.date)}
            />
            <ItemDetail
              name="Invoice Date"
              value={parseDate(showDetailInvoice.invoice_date)}
            />
            <ItemDetail
              name="Due Date"
              value={parseDate(showDetailInvoice.invoice_date_due)}
            />
            <ItemDetail
              name="Tax Exclude"
              value={currency(showDetailInvoice.amount_tax_signed, true)}
            />
            <ItemDetail
              name="Amount Due"
              value={currency(showDetailInvoice.total_amount, true)}
              valueBold={true}
              valueStyle={{ color: Colors.blue1 }}
            />
            <ItemDetail
              name="Invoice Status"
              centered
              value={<StatusBadge status={showDetailInvoice.status} />}
            />
            <ItemDetail
              name="Payment Status"
              centered
              withoutBorder={true}
              value={
                <StatusBadge status={showDetailInvoice.invoice_payment_state} />
              }
            />
          </ScrollView>
        }
      />

      <ModalHalf
        testID="todo-invoice-note-modal"
        title={editingNoteIndex >= 0 ? 'Edit Note' : 'Add Note'}
        visible={showNote}
        maxWidth={'100%'}
        onClose={() => {
          setShowNote(false);
          setEditingNoteIndex(-1);
          setPayloadInvoices([]);
          setPayloadInvoiceNotes('');
          setPayloadInvoiceAmount('');
          setPayloadInvoiceStatus('');
          setInvoiceAttachmentUrl('');
          setPayloadInvoiceDetails([]);
        }}
        children={
          <ScrollView style={{ width: '100%', padding: 15 }}>
            {editingNoteIndex >= 0 ? (
              <>
                <View style={{ width: '100%', marginBottom: 10 }}>
                  <Input
                    label="Invoice Number(s)"
                    value={payloadInvoices.join(', ')}
                    editable={false}
                  />
                </View>
                <View style={{ width: '100%', marginBottom: 10 }}>
                  <StatusPicker
                    testID="todo-invoice-edit-status-picker"
                    label="Status"
                    options={INVOICE_PAYMENT_STATUS_OPTIONS}
                    labelKey="label"
                    trackBy="value"
                    value={payloadInvoiceStatus}
                    onChange={(item) => updateEditInvoiceStatus(item.value)}
                  />
                </View>
                <View style={{ width: '100%', marginBottom: 10 }}>
                  <Input
                    label="Amount"
                    value={String(payloadInvoiceAmount)}
                    isNumeric={true}
                    editable={payloadInvoiceStatus === 'partially_paid'}
                    hasError={getInvoiceAmountError(
                      {
                        status: payloadInvoiceStatus,
                        amount: payloadInvoiceAmount,
                      },
                      getInvoiceMaxAmount(payloadInvoices[0]),
                    )}
                    onChangeText={(val) => setPayloadInvoiceAmount(val)}
                  />
                </View>
                <View style={{ width: '100%', marginBottom: 30 }}>
                  <Input
                    label="Notes"
                    value={payloadInvoiceNotes}
                    multiline={true}
                    numberOfLines={4}
                    onChangeText={(val) => setPayloadInvoiceNotes(val)}
                  />
                </View>
                <AttachmentField
                  url={invoiceAttachmentUrl}
                  onDownload={() =>
                    downloadFile(
                      invoiceAttachmentUrl,
                      'invoice-attachment',
                      '',
                      true,
                    )
                  }
                  onRemove={() => setInvoiceAttachmentUrl('')}
                  onChange={(value) => setInvoiceAttachmentUrl(value)}
                />
              </>
            ) : (
              payloadInvoiceDetails.map((detail, idx) => (
                <View key={idx} style={styles.noteDetailCard}>
                  <View style={{ width: '100%', marginBottom: 10 }}>
                    <Input
                      label="Invoice Number"
                      value={detail.invoiceId}
                      editable={false}
                    />
                  </View>
                  <View style={{ width: '100%', marginBottom: 10 }}>
                    <StatusPicker
                      testID={`todo-invoice-detail-status-picker-${idx}`}
                      label="Status"
                      options={INVOICE_PAYMENT_STATUS_OPTIONS}
                      labelKey="label"
                      trackBy="value"
                      value={detail.status}
                      onChange={(item) => updateInvoiceStatus(idx, item.value)}
                    />
                  </View>
                  <View style={{ width: '100%', marginBottom: 10 }}>
                    <Input
                      label="Amount"
                      value={String(detail.amount ?? '')}
                      isNumeric={true}
                      editable={detail.status === 'partially_paid'}
                      hasError={getInvoiceAmountError(
                        detail,
                        getInvoiceMaxAmount(detail.invoiceId),
                      )}
                      onChangeText={(val) =>
                        updateInvoiceDetail(idx, 'amount', val)
                      }
                    />
                  </View>
                  <View style={{ width: '100%', marginBottom: 10 }}>
                    <Input
                      label="Notes"
                      value={detail.text}
                      multiline={true}
                      numberOfLines={4}
                      onChangeText={(val) =>
                        updateInvoiceDetail(idx, 'text', val)
                      }
                    />
                  </View>
                  <AttachmentField
                    url={detail.invoice_attachment_url}
                    onDownload={() =>
                      downloadFile(
                        detail.invoice_attachment_url,
                        'invoice-attachment',
                        '',
                        true,
                      )
                    }
                    onRemove={() =>
                      updateInvoiceDetail(idx, 'invoice_attachment_url', '')
                    }
                    onChange={(value) =>
                      updateInvoiceDetail(idx, 'invoice_attachment_url', value)
                    }
                  />
                </View>
              ))
            )}
            <View style={{ width: '100%', marginBottom: 20 }}>
              <Button
                testID="todo-invoice-note-save-btn"
                rounded
                buttonStyle={{ width: '100%' }}
                disabledStyle={{ width: '100%' }}
                disabled={
                  editingNoteIndex >= 0
                    ? !isInvoiceDetailValid(
                        {
                          text: payloadInvoiceNotes,
                          status: payloadInvoiceStatus,
                          amount: payloadInvoiceAmount,
                        },
                        getInvoiceMaxAmount(payloadInvoices[0]),
                      )
                    : payloadInvoiceDetails.some(
                        (d) =>
                          !isInvoiceDetailValid(
                            d,
                            getInvoiceMaxAmount(d.invoiceId),
                          ),
                      )
                }
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.white,
                    }}>
                    {editingNoteIndex >= 0 ? 'Save' : 'Add'}
                  </SociollaText>
                }
                onPress={() => {
                  const tempResult = JSON.parse(JSON.stringify(lastPayload));
                  if (editingNoteIndex >= 0) {
                    tempResult[editingNoteIndex] = {
                      type: 'invoice',
                      invoice_number: payloadInvoices,
                      text: payloadInvoiceNotes,
                      invoice_attachment_url: invoiceAttachmentUrl,
                      amount_invoice: payloadInvoiceAmount,
                      status_invoice: payloadInvoiceStatus,
                    };
                  } else {
                    payloadInvoiceDetails.forEach((detail) => {
                      tempResult.push({
                        type: 'invoice',
                        invoice_number: [detail.invoiceId],
                        text: detail.text,
                        invoice_attachment_url: detail.invoice_attachment_url,
                        amount_invoice: detail.amount,
                        status_invoice: detail.status,
                      });
                    });
                  }
                  setLastPayload(tempResult);
                  setEditingNoteIndex(-1);
                  setPayloadInvoices([]);
                  setPayloadInvoiceNotes('');
                  setPayloadInvoiceAmount('');
                  setPayloadInvoiceStatus('');
                  setInvoiceAttachmentUrl('');
                  setPayloadInvoiceDetails([]);
                  addingMoreNote.current = false;
                  setShowResult(true);
                  setShowNote(false);
                }}
              />
            </View>
          </ScrollView>
        }
      />
    </View>
  );
};

const ResultNoteCard = ({ item, onEdit, onDelete }) => (
  <View style={styles.resultCard}>
    <View style={styles.resultCardHeader}>
      <View style={{ flex: 1, marginRight: 8 }}>
        <View style={styles.invoiceChipsRow}>
          {item.invoice_number?.length ? (
            item.invoice_number.map((num, i) => (
              <View key={i} style={styles.invoiceChip}>
                <SociollaText style={styles.invoiceChipText}>
                  {num}
                </SociollaText>
              </View>
            ))
          ) : (
            <SociollaText style={{ fontSize: 12, color: Colors.grey1 }}>
              -
            </SociollaText>
          )}
        </View>
      </View>
      <View style={styles.resultCardActions}>
        <TouchableOpacity
          testID="todo-invoice-note-edit-btn"
          style={styles.actionButton}
          activeOpacity={0.6}
          onPress={onEdit}>
          <Image
            style={{ width: 16, height: 16 }}
            width={16}
            height={16}
            svg={true}
            source={require('@assets/img/icons/edit-grey.svg')}
          />
        </TouchableOpacity>
        <TouchableOpacity
          testID="todo-invoice-note-delete-btn"
          style={styles.actionButton}
          activeOpacity={0.6}
          onPress={onDelete}>
          <Image
            style={{ width: trash.width, height: trash.height }}
            width={trash.width}
            height={trash.height}
            source={require('@assets/img/icons/trash-grey.svg')}
            svg={true}
          />
        </TouchableOpacity>
      </View>
    </View>
    <View style={styles.resultCardDivider} />
    <View style={styles.resultCardBody}>
      <View style={{ flex: 1 }}>
        <SociollaText style={styles.noteLabel}>Amount</SociollaText>
        <SociollaText type="medium" style={{ marginBottom: 8 }}>
          {item.amount_invoice || item.amount_invoice === 0
            ? currency(item.amount_invoice, true)
            : '-'}
        </SociollaText>
        <SociollaText style={styles.noteLabel}>Status</SociollaText>
        <View style={{ marginBottom: 12, alignSelf: 'flex-start' }}>
          {item.status_invoice ? (
            <StatusBadge status={item.status_invoice} />
          ) : (
            <SociollaText>-</SociollaText>
          )}
        </View>
        <SociollaText style={styles.noteLabel}>Notes</SociollaText>
        <ScrollView
          style={{
            maxHeight: 100,
          }}
          contentContainerStyle={{ padding: 12 }}
          showsVerticalScrollIndicator={false}>
          <SociollaText style={styles.noteText}>
            {item.text || '-'}
          </SociollaText>
        </ScrollView>
      </View>
      {!!item.invoice_attachment_url && (
        <TouchableOpacity
          testID="todo-invoice-note-attachment-btn"
          style={styles.attachmentBadge}
          activeOpacity={0.7}
          onPress={() =>
            downloadFile(
              item.invoice_attachment_url,
              'invoice-attachment',
              '',
              true,
            )
          }>
          <Image
            style={{ width: 14, height: 14 }}
            width={14}
            height={14}
            isResolveAsset
            source={require('@/assets/img/icons/attachment.png')}
          />
          <SociollaText style={styles.attachmentBadgeText}>
            Attachment
          </SociollaText>
        </TouchableOpacity>
      )}
    </View>
  </View>
);

const AttachmentField = ({ url, onDownload, onRemove, onChange }) => (
  <View style={styles.attachmentField}>
    <SociollaText style={styles.attachmentFieldLabel}>
      Invoice Attachment
    </SociollaText>
    {url ? (
      <View style={styles.attachmentFileRow}>
        <TouchableOpacity
          testID="todo-invoice-attachment-download-btn"
          style={styles.attachmentFileButton}
          activeOpacity={0.7}
          onPress={onDownload}>
          <Image
            style={{ width: 16, height: 16, marginRight: 6 }}
            width={16}
            height={16}
            isResolveAsset
            source={require('@/assets/img/icons/attachment.png')}
          />
          <SociollaText style={styles.attachmentFileName} numberOfLines={1}>
            {getFileNameFromUrl(url, 'Invoice')}
          </SociollaText>
        </TouchableOpacity>
        <TouchableOpacity
          testID="todo-invoice-attachment-remove-btn"
          style={styles.attachmentRemoveButton}
          activeOpacity={0.7}
          onPress={onRemove}>
          <Image
            style={{ width: 18, height: 18 }}
            width={18}
            height={18}
            svg={true}
            source={require('@assets/img/icons/close-circle-blue.svg')}
          />
        </TouchableOpacity>
      </View>
    ) : (
      <FileInput
        value={''}
        onChange={onChange}
        containerStyleExtra={styles.attachmentUploadForm}
      />
    )}
  </View>
);

const styles = StyleSheet.create({
  selectAllRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 15,
    paddingVertical: 10,
    backgroundColor: Colors.grey17,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
  },
  selectAllText: {
    fontSize: 13,
    color: Colors.grey13,
    marginLeft: 8,
  },
  emptyState: {
    paddingVertical: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyStateText: {
    fontSize: 13,
    color: Colors.grey1,
    textAlign: 'center',
  },
  orderItem: {
    width: '100%',
    paddingVertical: 14,
    paddingHorizontal: 15,
    backgroundColor: Colors.white,
    borderBottomWidth: 1,
    borderBottomColor: Colors.grey0,
    borderLeftWidth: 3,
    borderLeftColor: 'transparent',
  },
  orderItemSelected: {
    borderLeftColor: Colors.blue0,
    backgroundColor: '#f5f7ff',
  },
  orderItemSection: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  cardTopRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4,
  },
  invoiceNumber: {
    fontSize: 14,
    color: Colors.blue1,
    flex: 1,
    marginRight: 8,
  },
  invoiceOrigin: {
    fontSize: 12,
    color: Colors.grey1,
    marginBottom: 8,
  },
  cardBottomRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dueDateLabel: {
    fontSize: 11,
    color: Colors.grey13,
  },
  amountDue: {
    marginTop: 4,
    fontSize: 12,
    color: Colors.blue0,
  },
  selectionSummary: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 15,
    paddingVertical: 10,
    backgroundColor: Colors.blue1,
  },
  selectionSummaryCount: {
    fontSize: 13,
    color: Colors.white,
  },
  selectionSummaryTotal: {
    fontSize: 13,
    color: Colors.white,
  },
  resultCard: {
    width: '100%',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
    backgroundColor: Colors.white,
    overflow: 'hidden',
    marginBottom: 12,
  },
  resultCardHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: 12,
  },
  invoiceChipsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  invoiceChip: {
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 4,
    backgroundColor: '#eef1fb',
    marginBottom: 4,
    marginRight: 4,
  },
  invoiceChipText: {
    fontSize: 11,
    color: Colors.blue0,
  },
  resultCardActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  actionButton: {
    width: 32,
    height: 32,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    backgroundColor: Colors.grey15,
    marginLeft: 4,
  },
  resultCardDivider: {
    height: 1,
    backgroundColor: Colors.grey0,
  },
  resultCardBody: {
    padding: 12,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  noteLabel: {
    fontSize: 11,
    color: Colors.grey1,
    marginBottom: 4,
  },
  noteText: {
    fontSize: 12,
    color: Colors.grey14,
    lineHeight: 18,
  },
  attachmentBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    backgroundColor: Colors.grey15,
    marginLeft: 8,
    alignSelf: 'flex-start',
  },
  attachmentBadgeText: {
    fontSize: 10,
    color: Colors.grey13,
    marginLeft: 4,
  },
  noteDetailCard: {
    width: '100%',
    marginBottom: 20,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.grey0,
  },
  // Attachment field
  attachmentField: {
    width: '100%',
    marginBottom: 16,
  },
  attachmentFieldLabel: {
    fontSize: 12,
    color: Colors.grey1,
    marginBottom: 8,
  },
  attachmentFileRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  attachmentFileButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    height: isWeb ? 35 : 44,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: Colors.grey0,
    paddingHorizontal: 12,
    backgroundColor: Colors.grey17,
    marginRight: 8,
  },
  attachmentFileName: {
    fontSize: 13,
    color: Colors.blue0,
    flex: 1,
  },
  attachmentRemoveButton: {
    width: 36,
    height: 36,
    justifyContent: 'center',
    alignItems: 'center',
  },
  attachmentUploadForm: {
    borderRadius: 6,
    borderWidth: 1,
    height: isWeb ? 35 : 44,
    paddingHorizontal: 12,
    borderColor: Colors.grey0,
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export default React.memo(TodoInvoice, (prev, next) => prev == next);
